import styled from 'styled-components/macro';

export const EditorViewWrapper = styled.section`
  /* border: red solid 1px; */
`;
